import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import "react-toastify/dist/ReactToastify.css";
import DataTablePagination from "../../components/common/DataTablePagination/dataTablePagination";
import TableHeader from "../../components/common/TableHeader/tableHeader";
import ExportButtons from "../../components/ExportButtons";
import Loading from "../../components/loading";
import { useServicePoints } from '../../features/servicePoint/useServicePoints';
import FilterContainer from "./components/filterContainer";
import Table from './components/table';
import "./style.css";
const List = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language
    const [isfilter, setIsFilter] = useState()
    const { getExcelData, fetchData, servicePoints, isLoading, isError, itemsPerPage, total, currentPage, lastPage, setPage, setQueryString, setPerPge, queryString } = useServicePoints();
    const breadcrumbLinks = [
        { url: '/', icon: 'bx bx-home-alt', label: t('common.home') },
        { label: t('servicePoint.servicePoints') }
    ];

    useEffect(() => {
        const debouncedFetch = debounce(() => fetchData(), 300);
        debouncedFetch();
        return () => {
            if (debouncedFetch.cancel) {
                debouncedFetch.cancel();
            }
        };
    }, [isfilter, currentPage, itemsPerPage]);

    const infoData = [
        { text: t('more_info.service_point_amount'), data: '100' },
        { text: t('more_info.service_points_with_cabinet'), data: '50' },
        { text: t('more_info.service_points_without_cabinet'), data: '30' }
    ];

    if (isLoading) {
        return <Loading isLoading={isLoading} />;
    }
    if (isError) {
        return <Loading isLoading={false} isError={isError} />;
    }
    return (

        <div className="page-wrapper">
            <div className="page-content">
                <TableHeader
                    breadcrumbLinks={breadcrumbLinks}
                    addLink="/service-point/create"
                    addButtonText={t('servicePoint.addServicePoint')}
                />
                <div className="card">
                    {/* <MoreInfo infoData={infoData} /> */}
                    <FilterContainer setQueryString={setQueryString} setIsFilter={setIsFilter} />
                    <div className="card-body">
                        <ExportButtons
                            getFunction={getExcelData}
                            queryString={queryString}
                        // headers={["name", "address", "latitude", "longitude", "phone"]}
                        // excelHeaders={["name", "servicepoint_number", "area", "closing_time"]}
                        />
                        <Table
                            data={servicePoints}
                            lang={lang}
                        />
                        <DataTablePagination
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            total={total}
                            lastPage={lastPage}
                            handlePageClick={setPage}
                            setPerPge={setPerPge}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(List);
